"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

exports.__esModule = true;
exports.default = void 0;

var _react = require("react");

var _styledComponents = require("styled-components");

var _defaultTheme = _interopRequireDefault(require("../../defaultTheme"));

const useTheme = () => (0, _react.useContext)(_styledComponents.ThemeContext) || _defaultTheme.default;

var _default = useTheme;
exports.default = _default;